/**
 * MFA Challenge Page for Admin Console
 * 
 * This file re-exports the shared MfaChallengePage component,
 * wrapping it with admin-console specific navigation behavior.
 */

import { useNavigate, useLocation } from 'react-router-dom';
import { MfaChallengePage as SharedMfaChallengePage } from 'shared/components/auth';

export function MfaChallengePage(): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();

  // Get return URL from query params or navigation state
  const params = new URLSearchParams(location.search);
  const returnUrl = params.get('return_to') || 
    (location.state as { returnTo?: string })?.returnTo || 
    '/';

  const handleSuccess = () => {
    // Navigate to the return URL after successful MFA verification
    navigate(returnUrl, { replace: true });
  };

  const handleCancel = () => {
    // Return to login page
    navigate('/auth/login', { replace: true });
  };

  return (
    <SharedMfaChallengePage
      onSuccess={handleSuccess}
      onCancel={handleCancel}
      returnUrl={returnUrl}
    />
  );
}

export default MfaChallengePage;
